export const compose = (pipeline, value) => pipeline.reduce((acc, curr) => curr(acc), value);
//# sourceMappingURL=compose.js.map